import { useMemo } from 'react';
import { assert } from '@varos/util-typescript';
import { ChatLoaderBaseConfig } from '../../../../../base';
import { SolutionContextLodaer } from './solutionContextInterface';
import { SolutionAggregate } from './solutionContextModel';

export function createSolutionContextLoader(
    config: ChatLoaderBaseConfig
): SolutionContextLodaer {
    const { repository } = config;

    return {
        useLoad(context): SolutionAggregate {
            console.log('[SolutionLoader] useLoad called');

            // Use platform integration tool repository to fetch integration tools (solutions)
            const integrationToolQuery = repository.platform.integrationTool.useFind(
                context,
                {},
                { suspense: false }
            );

            console.log('[SolutionLoader] Query status:', integrationToolQuery.status);
            console.log('[SolutionLoader] Query data:', integrationToolQuery.data);

            // Get integration tools, defaulting to empty array for loading/error states
            const integrationTools =
                integrationToolQuery.status === 'success'
                    ? integrationToolQuery.data || []
                    : [];

            // Memoize the aggregate to ensure stable references (always call useMemo)
            const aggregate = useMemo(() => {
                const result = {
                    solutions: integrationTools,
                };
                console.log('[SolutionLoader] Created aggregate:', result);
                return result;
            }, [integrationTools]);

            return aggregate;
        },
    };
}
